import { subcategories } from "@aclymatepackages/subcategories";

export const scopeThreeSpendBasedCategories = subcategories.filter(
  ({ category }) => category === "Scope Three Category"
);
